export default __webpack_public_path__ + "static/media/Avatar.6191c044.svg";